<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'myprofile'" [businessName]="vm.businessName"
    [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row  pt-4">
        <div class=" section-header col-md-6 ">My Account</div>
        <div class="col-md-6 pr-2 text-right">
            <button class="btn btn-link" (click)="changePassword()">Change Password</button>
        </div>
    </div>
    <div>
        <hr class="mt-0" />
    </div>

    <div class="form">
        <div class="row">
            <div class="col-xl-8 col-lg-9 col-md-10 pb-2 order-lg-1 order-2">

                <div class="row pb-1">
                    <div class="col-md-6">
                        <label>Business Name *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('clientName')}" name="clientName"
                            placeholder="" type="text" [(ngModel)]="vm.clientName">
                        <div class="invalid-feedback"> {{error('clientName')}} </div>
                    </div>
                    <div class="col-md-6">
                        <label>ABN </label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('abn')}" name="abn" placeholder=""
                            type="text" [(ngModel)]="vm.abn">
                        <div class="invalid-feedback"> {{error('abn')}} </div>
                    </div>
                </div>



                <div class="row mb-1">
                    <div class="col-md-6">
                        <label>First Name *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('firstName')}" name="firstName"
                            placeholder="" type="text" [(ngModel)]="vm.firstName">
                        <div class="invalid-feedback"> {{error('firstName')}} </div>

                    </div>

                    <div class="col-md-6">
                        <label>Last Name *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('lastName')}" name="lastName"
                            placeholder="" type="text" [(ngModel)]="vm.lastName">
                        <div class="invalid-feedback"> {{error('lastName')}} </div>

                    </div>
                </div>


                <div class="row pb-1">
                    <div class="col-md-6">
                        <label for="email">Email *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('email')}" name="email"
                            placeholder="" type="text" [(ngModel)]="vm.email">
                        <div class="invalid-feedback"> {{error('email')}} </div>
                    </div>
                    <div class="col-md-6 pt-4 mt-1 pl-4">

                        <div *ngIf="!vm.isEmailValidated">
                            <i class="fas fa-info-circle" style="color:#0088BB"></i>
                            Email not yet validated,
                            <button class="btn btn-link"
                                style="padding: unset; font-size: unset;text-align: unset;vertical-align: unset;"
                                (click)="validateEmail()">click here</button> to validate.
                        </div>
                        <div *ngIf="vm.isEmailValidated"><i class="fas fa-check" style="color:green"></i> Email
                            Validated</div>
                    </div>
                </div>


                <div class="row pb-1">
                    <div class="col-md-6">
                        <label for="workPhone">Work Phone *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('workPhone')}" name="workPhone"
                            placeholder="e.g. (03) 5555 1234" type="text" [(ngModel)]="vm.workPhone"
                            (keyup)="formatPhone('workPhone')">
                        <div class="invalid-feedback"> {{error('workPhone')}} </div>

                    </div>
                    <div class="col-md-6">
                        <label for="mobilePhone">Mobile Phone *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('mobilePhone')}"
                            name="mobilePhone" placeholder="e.g. 0455 355 355" type="text" [(ngModel)]="vm.mobilePhone"
                            (keyup)="formatPhone('mobilePhone')">
                        <div class="invalid-feedback"> {{error('mobilePhone')}} </div>

                    </div>
                </div>

                <div class="row  pb-1 ">
                    <div class="col-md-6">
                        <label for="businessTypeId">Type of Business *</label>
                        <select class="form-control" [ngClass]="{'is-invalid': !!error('businessTypeId')}"
                            name="businessTypeId" [(ngModel)]="vm.businessTypeId">
                            <option [ngValue]="0"></option>
                            <option *ngFor="let c of vm.businessTypes" [ngValue]="c.businessTypeId">
                                {{c.description}}</option>
                        </select>
                        <div class="invalid-feedback"> {{error('businessTypeId')}} </div>
                    </div>
                    <div class="col-md-6"
                        *ngIf="vm.businessTypeId && vm.businessTypeId.toUpperCase() == '59BA4193-9F7B-48DE-B2C1-B7BD7D2D5AD1'">
                        <label>Business Description *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('businessTypeOther')}"
                            name="businessTypeOther" [(ngModel)]="vm.businessTypeOther">
                        <div class="invalid-feedback"> {{error('businessTypeOther')}} </div>
                    </div>
                </div>

                <div class="row pt-4">
                    <div class="col">
                        <h6 class="font-weight-bold">Business Address</h6>
                    </div>
                </div>

                <div class="row mb-1">
                    <div class="col">
                        <label>Search Address</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'addressSearch')}"
                            name="addressSearch" placeholder="Start typing your business address here" type="text"
                            [(ngModel)]="vm.addressSearch" [readonly]="vm.isAddressNotFound"
                            ngx-google-places-autocomplete (onAddressChange)="handleAddressChange($event)"
                            [options]="googlePlacesOptions">
                        <div class="invalid-feedback"> {{error(vm,'addressSearch')}} </div>

                    </div>
                </div>

                <div class="row pb-2 pt-2">
                    <div class="col">
                        <div class="form-check">
                            <input style="cursor:pointer;" class="form-check-input" name="isAddressNotFound"
                                type="checkbox" value="true" (change)="addressNotFoundChanged()" id="isAddressNotFound"
                                [(ngModel)]="vm.isAddressNotFound"
                                [ngClass]="{'is-invalid': !!error(vm,'isAddressNotFound')}">
                            <span>I cannot find my business address</span>
                        </div>
                    </div>
                </div>

                <div class="row pb-1">
                    <div class="col">
                        <label>Address Line 1 *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('address1')}" name="address1"
                            placeholder="" type="text" [(ngModel)]="vm.address1"
                            [readonly]="!vm.isAddressNotFound"
                            (change)='updateBillingAddress()'>
                        <div class="invalid-feedback"> {{error('address1')}} </div>

                    </div>
                </div>

                <div class="row pb-1">
                    <div class="col">
                        <label>Address Line 2 </label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('address2')}" name="address2"
                            placeholder="" type="text" [(ngModel)]="vm.address2"
                            [readonly]="!vm.isAddressNotFound"
                            (change)='updateBillingAddress()'>
                        <div class="invalid-feedback"> {{error('address2')}} </div>

                    </div>
                </div>

                <div class="row  pb-1">
                    <div class="col-md-6">
                        <label>Suburb *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('suburb')}" name="suburb"
                            placeholder="" type="text" [(ngModel)]="vm.suburb"
                            [readonly]="!vm.isAddressNotFound"
                            (change)='updateBillingAddress()'>
                        <div class="invalid-feedback"> {{error('suburb')}} </div>

                    </div>

                    <div class="col-md-2">
                        <label>State *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('state')}" name="state"
                            placeholder="" type="text" [(ngModel)]="vm.state"
                            [readonly]="!vm.isAddressNotFound"
                            (change)='updateBillingAddress()'>
                        <div class="invalid-feedback"> {{error('state')}} </div>

                    </div>

                    <div class="col-md-4">
                        <label>Postcode *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('postCode')}" name="postCode"
                            placeholder="" type="text" [(ngModel)]="vm.postCode"
                            [readonly]="!vm.isAddressNotFound"
                            (change)='updateBillingAddress()'>
                        <div class="invalid-feedback"> {{error('postCode')}} </div>

                    </div>
                </div>

                <div class="row pt-4">
                    <div class="col">
                        <h6 class="font-weight-bold">Billing Address</h6>
                    </div>
                </div>


                <div class="row pb-1">
                    <div class="col-md-6">
                        <label>Is Billing Address same as Business Address?</label>

                        <div>
                            <div class="form-check-inline">
                                <input class="form-check-input" type="radio" (click)="copyBusinessAddress()"
                                    name="isSameAddress1" id="isSameAddress1" style="cursor:pointer;" [value]="true"
                                    [(ngModel)]="vm.isSameAddress">
                                <span>Yes</span>

                            </div>
                            <div class="form-check-inline">
                                <input class="form-check-input" type="radio" (click)="clearBillingAddress()"
                                    name="isSameAddress2" id="isSameAddress2" style="cursor:pointer;" [value]="false"
                                    [(ngModel)]="vm.isSameAddress">
                                <span>No</span>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-1" [hidden]="vm.isSameAddress">
                    <div class="col">
                        <label>Search Address</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingAddressSearch')}"
                            name="billingAddressSearch" placeholder="Start typing your billing address here" type="text"
                            [(ngModel)]="vm.billingAddressSearch" ngx-google-places-autocomplete
                            (onAddressChange)="handleBillingAddressChange($event)" [options]="googlePlacesOptions"
                            [readonly]="vm.isSameAddress || (!vm.isSameAddress && vm.isBillingAddressNotFound)">
                        <div class="invalid-feedback"> {{error(vm,'billingAddressSearch')}} </div>

                    </div>
                </div>

                <div class="row pb-2 pt-2" [hidden]="vm.isSameAddress">
                    <div class="col">
                        <div class="form-check">
                            <input style="cursor:pointer;" class="form-check-input" name="isBillingAddressNotFound"
                                type="checkbox" value="true" (change)="billingAddressNotFoundChanged()"
                                id="isBillingAddressNotFound" [(ngModel)]="vm.isBillingAddressNotFound"
                                [ngClass]="{'is-invalid': !!error(vm,'isBillingAddressNotFound')}"
                                [readonly]="vm.isSameAddress">
                            <span>I cannot find my billing address</span>
                        </div>
                    </div>
                </div>

                <div class="row pb-1">
                    <div class="col">
                        <label>Address Line 1 *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('billingAddress1')}"
                            name="billingAddress1" placeholder="" type="text" [(ngModel)]="vm.billingAddress1"
                            [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                        <div class="invalid-feedback"> {{error('billingAddress1')}} </div>

                    </div>
                </div>

                <div class="row pb-1">
                    <div class="col">
                        <label>Address Line 2 </label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('billingAddress2')}"
                            name="billingAddress2" placeholder="" type="text" [(ngModel)]="vm.billingAddress2"
                            [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                        <div class="invalid-feedback"> {{error('billingAddress2')}} </div>

                    </div>
                </div>

                <div class="row  pb-1">
                    <div class="col-md-6">
                        <label>Suburb *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('billingSuburb')}"
                            name="billingSuburb" placeholder="" type="text" [(ngModel)]="vm.billingSuburb"
                            [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                        <div class="invalid-feedback"> {{error('billingSuburb')}} </div>

                    </div>

                    <div class="col-md-2">
                        <label>State *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('billingState')}"
                            name="billingState" placeholder="" type="text" [(ngModel)]="vm.billingState"
                            [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                        <div class="invalid-feedback"> {{error('billingState')}} </div>

                    </div>

                    <div class="col-md-4">
                        <label>Postcode *</label>
                        <input class="form-control" [ngClass]="{'is-invalid': !!error('billingPostCode')}"
                            name="billingPostCode" placeholder="" type="text" [(ngModel)]="vm.billingPostCode"
                            [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                        <div class="invalid-feedback"> {{error('billingPostCode')}} </div>
                    </div>
                </div>


                <div class="pt-2">
                    <hr class="mt-0" />
                </div>

            </div>
            <div class="col-lg-3 col-md  order-lg-2 order-1">

                <div class="card">
                    <div class="card-body ">

                        <div class="row">
                            <div class="col">
                                <label>Permit Number</label>
                                <div>
                                    {{vm.permitNo}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label>Permit Activation Date</label>
                                <div>
                                    {{vm.startDate | date:"dd/MM/yyyy" }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label>Customer Number</label>
                                <div>
                                    {{!!vm.hiAffinityNo ? vm.hiAffinityNo : 'N/A' }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label>Status</label>
                                <div>
                                    {{vm.status}}
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="vm.status !='New'">
                            <div class="col">
                                <label *ngIf="vm.status =='Expired'" for="status">Expired On</label>
                                <label *ngIf="vm.status =='Active'" for="status">Expires On</label>
                                <div>
                                    {{vm.expiryDate | date:"dd/MM/yyyy"}}
                                </div>
                                <!-- Test code to be removed -->
                                <div><br />
                                    <div *ngIf="!vm.isEmailValidated">
                                        <i class="fas fa-users" style="color:#0088BB"></i>
                                        Add a new mobile user account
                                        <button class="btn btn-link"
                                            style="padding: unset; font-size: unset;text-align: unset;vertical-align: unset;"
                                            (click)="addPermitAdminMobileUser()">click here</button> 
                                    </div>
                                </div>
                                <!-- Test code to be removed -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <input class="form-check-input" type="hidden" [ngClass]="{'is-invalid': hasErrors()}">
                <div class="invalid-feedback">
                    <h5><i class="fas fa-exclamation-triangle"></i> The form contains errors, please review errors and
                        try again</h5>
                </div>
            </div>
        </div>
        <div class="row pb-4">

            <div class="col-xl-8 col-lg-9 col-md-10 ">

                <div class="row">
                    <div class="col-md-6 mb-2">
                    </div>
                    <div class="col-md-6 mb-2 d-flex justify-content-end ">
                        <div class="pr-2">
                            <button class="btn btn-primary" (click)="save()">Update Details</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <cli-yes-cancel-modal #sendValidationModal [id]="'sendValidationModal'">
    </cli-yes-cancel-modal>
</div>